import { defineItemMigration } from "@editor/items/itemStoreMigration";
import type { SimulationItem } from "../SimulationItem";

export default defineItemMigration<SimulationItem, SimulationItem>(
  (itemStore, oldSimulation, newSimulation) => {
    const actionPlans = newSimulation.actionPlans;
    for (const roundIndex in actionPlans) {
      const actionPlan = actionPlans[roundIndex];

      for (const scheduledEffect of actionPlan.scheduledEffects) {
        const oldExpression = scheduledEffect.impulseExpressions[0];
        if (oldExpression == null) {
          continue;
        }

        // Remove the minValue and maxValue from the expression
        // and change them to functions:
        // @{e0}.$minValue -> #minValue(@{e0})
        let newExpression = oldExpression.replace(
          /(@\{[ier](\d+)\})\.\$\{(minValue|maxValue)\}/g,
          "#$2($1)"
        );
        // Remove "value" attribute queries:
        newExpression = newExpression.replace(
          /(@\{[ier](\d+)\})\.$\{value\}/g,
          "$1"
        );

        const itemReferenceKey =
          scheduledEffect.affectedType[0] + scheduledEffect.affectedId;
        // Replace all direct $maxValue/$minValue references with
        // #maxValue/#minValue functions:
        // e.g: $maxValue -> #maxValue(@{e0})
        newExpression = newExpression.replace(
          /\$\{(minValue|maxValue)\}/g,
          "#$1(@{" + itemReferenceKey + "})"
        );

        // Replace all direct $value references with the item reference:
        // e.g: $value -> @{e0}
        newExpression = newExpression.replace(
          /\$\{value\}/g,
          "@{" + itemReferenceKey + "}"
        );

        // Replace percentage references with the item reference:
        // e.g: 5% -> (5/100)*@{e0}
        newExpression = newExpression.replace(
          /([\d.]+)%/g,
          "($1/100)*@{" + itemReferenceKey + "}"
        );

        // Replace the old expression with the new one:
        scheduledEffect.impulseExpressions[0] = newExpression;
      }
    }
    return newSimulation;
  }
);
